export default __webpack_public_path__ + "static/media/why1.fabeb5b1.svg";